import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import type { IResourceModel } from '@/shared/model/briefing-widget.model';
import moment from 'moment';
import { isNullish } from '@/util/ds-util';
import { formatDateAgo } from '@/util/date-util';
import { getFaviconByUrl } from '@/util/common-util';
import VideoWidget from '@/shared/cards/briefing/resource/video-widget/video-widget.vue';
import ArticleWidget from '@/shared/cards/briefing/resource/article-widget/article-widget.vue';
import SocialWidget from '@/shared/cards/briefing/resource/social-widget/social-widget.vue';
import FileWidget from '@/shared/cards/briefing/resource/file-widget/file-widget.vue';

@Component({
  components: {
    'video-card': VideoWidget,
    'article-card': ArticleWidget,
    'social-card': SocialWidget,
    'file-card': FileWidget,
  },
  methods: { getFaviconByUrl, isNullish, formatDateAgo },
  computed: {
    moment() {
      return moment;
    },
  },
})
export default class DiscoveryWidget extends Vue {
  @Prop(Object) readonly formModel: IResourceModel;
  @Prop(Boolean) readonly isHideOptions: boolean;
  @Prop(Boolean) readonly isHideHidden: boolean;
  @Prop(Boolean) readonly isHideGoover: boolean;
  @Prop(Boolean) readonly isHideShared: boolean;
  @Prop(Boolean) readonly isHideAddReference: boolean | false;

  @Emit('share') share() {}

  @Emit('hide') hide() {}

  @Emit('select-user-social') selectUserSocial() {}

  @Emit('view-detail') viewDetail() {}

  @Emit('toggle-resource') toggleResource() {}

  @Emit('add-to-reference') addToReference() {}

  @Emit('goover') goover() {}

  // mounted() {
  //   console.log(this.formModel);
  // }

  get type() {
    if (this.formModel.url?.includes('www.youtube.com') || this.formModel.originParentDocDetail?.source_uri?.includes('www.youtube.com')) {
      return 'VIDEO';
    } else if (
      this.formModel.url?.includes('x.com') ||
      this.formModel.originParentDocDetail?.source_uri?.includes('x.com') ||
      this.formModel.url?.includes('www.facebook.com') ||
      this.formModel.originParentDocDetail?.source_uri?.includes('www.facebook.com')
    ) {
      return 'SOCIAL';
    } else if (
      this.formModel.url?.includes('drive.google.com') ||
      this.formModel.originParentDocDetail?.source_uri?.includes('drive.google.com') ||
      this.formModel.url?.includes('onedrive.live.com') ||
      this.formModel.originParentDocDetail?.source_uri?.includes('onedrive.live.com') ||
      this.formModel.url?.includes('dropboxusercontent.com') ||
      this.formModel.originParentDocDetail?.source_uri?.includes('dropboxusercontent.com')
    ) {
      return 'FILE';
    }
    return 'ARTICLE';
  }
}
